// Franse teksten voor gemiste taken in de ouderapp (zie missedApp.nl.ts).
export const appMissedFr = {
    line: {
        one: '{count} tâche manquée la semaine passée',
        other: '{count} tâches manquées la semaine passée',
    },
    lineSub: 'Cocher quand même ou passer',
    open: 'Voir',
    title: 'Manquées',
    description: 'Les tâches de la semaine passée restées ouvertes. Cochez-les quand même ou passez-les. Les points comptent comme ce jour-là.',
    done: 'Faite quand même',
    doneLabel: 'Faite quand même : {title}, {name}',
    skip: 'Passer',
    skipLabel: 'Passer : {title}, {name}',
    undo: 'Annuler',
    undoLabel: 'Annuler : {title}, {name}',
    markedDone: '{title} cochée quand même',
    markedSkipped: '{title} passée',
    undone: '{title} est de nouveau dans les manquées',
    stateDone: 'Faite',
    stateSkipped: 'Passée',
    allDone: 'Plus rien de manqué. Tout est à jour.',
};
//# sourceMappingURL=missedApp.fr.js.map